import React, {useEffect, useState} from 'react'
import {Button, message, Modal, Spin} from "antd"
import {getPhoneList} from "../../../../services/api/apiCheckHotLine"
import parseToken from "../../../../helpers/parseToken"

PopupListPhone.propTypes = {}

function PopupListPhone(props) {
    const {idListHotline, visible, onCancel} = props
    const [loading, setLoading] = useState(false)
    const [listPhone, setListPhone] = useState(false)

    const _fetchListHotline = async () => {
        setLoading(true)

        try {
            const decodeToken = parseToken()

            const response = await getPhoneList(idListHotline.type, idListHotline.id, decodeToken.sub)

            const {success, error_message, data} = response

            if (parseInt(success) !== 1) {
                setLoading(false)
                return message.error(error_message)
            }

            setLoading(false)
            setListPhone(data)
        } catch (e) {
            message.error(e.messages)
        }
    }

    useEffect(() => {
        if (visible) {
            _fetchListHotline()
        }
        // eslint-disable-next-line
    }, [visible]);

    return (
        <Modal
            title="Danh sách hotline"
            className="custom-list-phone"
            maskClosable={false}
            visible={visible}
            onCancel={onCancel}
            footer={[
                <Button key="back" type="primary" onClick={onCancel}>
                    Close
                </Button>
            ]}
        >
            <Spin spinning={loading} tip='Đang lấy thông tin sô hotline...'>
                <div className="ContentPage">
                    <div className="CustomersTable">
                        <table>
                            <thead className='CustomersHead'>
                            <tr>
                                <th>STT</th>
                                <th>Số hotline</th>
                            </tr>
                            </thead>
                            <tbody className='CustomersBody'>
                            {listPhone && listPhone.length > 0 ? listPhone.map((item, index) => (
                                <tr key={index} className='CustomersItem'>
                                    <td>{index + 1}</td>
                                    <td>{item.phoneNumber}</td>
                                </tr>
                            )) : <tr className='CustomersItem'>
                                <td colSpan={2}>Không có bản ghi nào</td>
                            </tr>}
                            </tbody>
                        </table>
                    </div>
                </div>
            </Spin>
        </Modal>
    )
}

export default PopupListPhone
